// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
var fromString = function (str) {
    return $foreign.fromStringImpl(str, $foreign["isFinite"], Data_Maybe.Just.create, Data_Maybe.Nothing.value);
};
export {
    nan,
    isNaN,
    infinity,
    isFinite
} from "./foreign.js";
export {
    fromString
};
//# sourceMappingURL=index.js.map
